import * as PropTypes from 'prop-types';
import { ColorsArray } from './palette.const';
export var ptColor = PropTypes.oneOf(ColorsArray);
export var ptSize = PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']);